import * as React from "react";
const SvgWhiteboard = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 2.58c0-.967.784-1.75 1.75-1.75h18c.966 0 1.75.783 1.75 1.75v10A1.75 1.75 0 0 1 21 14.33h-8.25v2.74l5.73 4.775a.75.75 0 0 1-.96 1.152l-4.77-3.975v2.557a.75.75 0 0 1-1.5 0v-2.557l-4.77 3.975a.75.75 0 1 1-.96-1.152l5.73-4.775v-2.74H3a1.75 1.75 0 0 1-1.75-1.75v-10ZM6 12.83h12a.25.25 0 1 0 0-.5H6a.25.25 0 1 0 0 .5Zm13.732 0a1.75 1.75 0 0 0-1.732-2H6a1.75 1.75 0 0 0-1.732 2H3a.25.25 0 0 1-.25-.25v-10A.25.25 0 0 1 3 2.33h18a.25.25 0 0 1 .25.25v10a.25.25 0 0 1-.25.25h-1.268Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgWhiteboard;
